import React, { useCallback, useState } from 'react';
import { Grid } from '@material-ui/core';
import useForm from 'react-hook-form';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { clearStore, getContract } from '../../redux/modules/contractValidation';
import ScrollToTopPage from '../../components/ScrollToTopPage';
import EfesContentHeader from '../../components/EfesContentHeader';
import Loader from '../../components/Loaders/Loader';
import WarningIcon from '../../components/MUI/Icons/WarningIcon';
import PolicySearchForm from '../../components/FormComponents/PolicySearchForm';
import useRegisterValidationFields from '../../hooks/useRegisterValidationFields';
import useUnRegisterValidationFields from '../../hooks/useUnRegisterValidationFields';
import contractValiditySchema from '../../validations/contract/contractValiditySchema';
import { tableDateFormat } from '../../helpers/dates';

import ValidateRecurringContractIcon from '../../styles/svgs/validateRecurringContract.svg';
import styles from './styles.module.scss';

import ClaimStatusIcon from '../../img/claims/claimStatus.svg';

const CheckContractPolicy = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { contract, isLoading, error } = useSelector(
    (store) => store.contractValidationReducer,
    shallowEqual,
  );
  const {
    handleSubmit,
    register,
    unregister,
    errors,
    setValue,
    triggerValidation,
    clearError,
  } = useForm({
    validationSchema: contractValiditySchema,
  });

  useRegisterValidationFields(['policyNumber'], register);
  useUnRegisterValidationFields(['policyNumber'], unregister);

  const [policyNumber, setPolicyNumber] = useState('');

  const clearContractData = useCallback(() => {
    dispatch(clearStore());
  }, [dispatch]);

  const onSubmit = useCallback(
    (data) => {
      clearContractData();
      dispatch(
        getContract({
          policyNumber: data.policyNumber
            .replace('/', '')
            .replace(/\s+/g, '')
            .toUpperCase(),
          type: 'travel',
        }),
      );
    },
    [dispatch, clearContractData],
  );

  return (
    <div id={styles.checkPolicy}>
      <ScrollToTopPage />
      <EfesContentHeader
        headerText="checkPolicy.headerInfo"
        headerImage={ClaimStatusIcon}
        imageWidth={63}
      />
      {isLoading && <Loader />}
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Grid container>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <PolicySearchForm
              formProps={{ handleSubmit, errors, clearError, setValue, triggerValidation, onSubmit }}
              setPolicyNumber={setPolicyNumber}
              policyNumber={policyNumber}
              isLoading={isLoading}
              gridSize={12}
            />
          </Grid>

          <Grid item xs={12} lg={8}>
            {contract && contract.isError === 0 && (
            <p className={styles.checkPolicyMessage}>
              {t('checkPolicy.policyValidRange', {
                activeFrom: tableDateFormat(contract.result.activeFrom),
                activeTo: tableDateFormat(contract.result.activeTo),
              })}
            </p>
            )}
            {!isEmpty(error) && (
            <p className={styles.errorMessage}>
              <WarningIcon />
              {t('checkPolicy.policyDoesntExist')}
            </p>
            )}
            <div className={styles.checkPolicyInfoBlock}>
              {
                 isEmpty(contract) && (
                 <img src={ValidateRecurringContractIcon} alt="" />
                 )
              }
              <p
                dangerouslySetInnerHTML={{
                  __html: t('checkPolicy.footerInfo'),
                }}
              />
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default CheckContractPolicy;
